<template>
  <button
    type="button"
    :disabled="isDisabled"
    class="ba-px-5 ba-py-3 ba-rounded-full ba-select-none"
    :class="classes"
    @click.prevent="$emit('click')"
  >
    <span class="ba-leading-none ba-whitespace-no-wrap ba-tracking-wide ba-font-semibold ba-text-inherit">История согласования</span>
  </button>
</template>

<script>
export default {
  name: "vis-approval-queue-history-control",
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        'ba-text-white ba-bg-accent ba-duration-150 hover:ba-bg-primary':
          !this.isDisabled,
        'ba-text-text-blue-grey ba-bg-background-blocks ba-cursor-not-allowed':
          this.isDisabled
      }
    }
  }
}
</script>
